import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  auth: localStorage.getItem("auth"),
};

const AuthSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    login: (state) => {
      state.auth = true;
      localStorage.setItem("auth", true);
    },
    logout: (state) => {
      state.auth = false;
      localStorage.setItem("auth", false);
    },
  },
});
export default AuthSlice;

export const { login, logout } = AuthSlice.actions;

